<template>
    <GrailCategory
        ref="refGrailCategory"
        @start="onCategoryStart"
        @complete="emit('revealComplete', true)"
        :category="category"
        v-if="category"
    />
    <LightsDown
        ref="refLightsDown"
        @start="onLightsDownStart"
        @complete="emit('revealComplete', true)"
    />
    <GrailTunnel
        ref="refGrailTunnel"
        @start="onGrailTunnelStart"
        @complete="emit('revealComplete')"
    />
</template>

<script setup>
    import { onBeforeUnmount, ref } from 'vue';

    import { disposeObject } from '@resn/gozer-three/helpers';
    import { useThreeObject } from '@resn/gozer-vue';

    import GrailCategory from './modules/GrailCategory/GrailCategory.vue';
    import GrailTunnel from './modules/GrailTunnel/GrailTunnel.vue';
    import LightsDown from './modules/LightsDown/LightsDown.vue';
    import { GRAIL_REVEALS, PackCategories } from '~/core/constants';

    const refGrailTunnel = ref(null);

    const props = defineProps({
        category: { type: String, default: null },
    });

    const refGrailCategory = ref(null);
    const refLightsDown = ref(null);

    const { object } = useThreeObject(null, { name: 'GrailReveals' });

    const selectRandomReveal = () => {
        const revealIds = [GRAIL_REVEALS.LIGHTS_DOWN, GRAIL_REVEALS.TUNNEL];
        const index = Math.floor(Math.random() * revealIds.length);

        return revealIds[index];
    };

    const show = ({ fast = false } = {}) => {
        const category = props.category?.toLowerCase?.() ?? null;
        // const type = GRAIL_REVEALS.LIGHTS_DOWN;
        const type = fast
            ? GRAIL_REVEALS.TUNNEL
            : !category || category === PackCategories.multisport
              ? selectRandomReveal()
              : GRAIL_REVEALS.CATEGORY;

        let reveal;
        switch (type) {
            case GRAIL_REVEALS.CATEGORY:
                reveal = refGrailCategory.value;
                break;
            case GRAIL_REVEALS.LIGHTS_DOWN:
                reveal = refLightsDown.value;
                break;
            case GRAIL_REVEALS.TUNNEL:
                reveal = refGrailTunnel.value;
                break;
        }

        reveal.show({ fast });

        return type;
    };

    const onCategoryStart = () => {
        emit('lightsDownStart', { type: GRAIL_REVEALS.CATEGORY });
    };
    const onLightsDownStart = () => {
        emit('lightsDownStart', { type: GRAIL_REVEALS.LIGHTS_DOWN });
    };
    const onGrailTunnelStart = () => {
        emit('lightsDownStart', { type: GRAIL_REVEALS.TUNNEL });
    };

    const destroy = () => {
        disposeObject(object);
    };

    onBeforeUnmount(destroy);

    defineExpose({ show });

    const emit = defineEmits(['revealComplete', 'categoryStart', 'lightsDownStart']);
</script>
